/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_No_Officials_HintInputs */



/**
* | output |
* | --- |
* | "Officials will appear here once data is synced." |
*
* @param {Community_No_Officials_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_no_officials_hint = /** @type {((inputs?: Community_No_Officials_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_No_Officials_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les officiels apparaîtront ici une fois les données synchronisées.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los oficiales aparecerán aquí una vez que los datos estén sincronizados.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os oficiais aparecerão aqui assim que os dados forem sincronizados.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gli ufficiali appariranno qui una volta sincronizzati i dati.")
	return /** @type {LocalizedString} */ ("Officials will appear here once data is synced.")
});